import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';
import { createUseStyles } from 'react-jss';

const styles: ComponentStylesProps<number> = {
  content: {
    paddingBottom: '5rem',
  },
  tableWrapper: {
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    marginBottom: '5rem',
    paddingBottom: '1rem',
    overflow: 'hidden',
    boxShadow: boxShadows.dark[2],
  },
  infoWrapper: {
    display: 'flex',
    marginBottom: '5rem',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  table: {
    width: 'max(100%, 135rem)',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
